import { FormattedMessage } from "react-intl";

import { useMatchScreenClass } from "common/core/responsive";
import { CompletionRequirement } from "graphql_globals";
import Svg from "common/core/svg";
import { WistiaPlayer } from "common/core/wistia_video";
import { Heading, Paragraph } from "common/core/typography";
import EsignImage from "assets/images/esign.svg";

import { TwoColumnMediaSection } from "../mobile_web_qr_code";
import Styles from "./how_this_works.module.scss";

const GUEST_UPLOAD_VIDEO_ID = "z1f7ha0zdb";

export function HowThisWorksSection({
  completionRequirement,
}: {
  completionRequirement: CompletionRequirement;
}) {
  const isEsign = completionRequirement === CompletionRequirement.ESIGN;
  const isMedium = useMatchScreenClass("xs", "sm", "md");

  return (
    <div className={Styles.wrapper} data-growth-id="qr-mobile-container">
      <div className={Styles.container}>
        <TwoColumnMediaSection
          leftColumn={
            isEsign ? (
              <div className={Styles.leftColumnImage}>
                <Svg alt="" src={EsignImage} />
              </div>
            ) : (
              <WistiaPlayer videoId={GUEST_UPLOAD_VIDEO_ID} />
            )
          }
          rightColumn={
            <div className={Styles.guestHowContainer}>
              <div className={Styles.guestHow}>
                <Heading level="h2" textStyle="headingThree">
                  <FormattedMessage
                    id="23467ad1-1387-4916-ac32-81b453066e01"
                    defaultMessage="How this works"
                  />
                </Heading>
                <Paragraph>
                  {isEsign ? (
                    <FormattedMessage
                      id="6d0414b5-4330-48fe-a7e4-4833a634762a"
                      defaultMessage="Signing a document with Proof is easy. Simply upload or scan your document, apply your signature, and download or share your documents. Price starts at $4."
                    />
                  ) : (
                    <FormattedMessage
                      id="190d92f3-0f71-462a-b3b5-802774786486"
                      defaultMessage="Getting a document notarized is easy. Simply upload your docs, verify your identity and you will be connected to a notary via an online meeting. Notaries on the Notarize Network are always online and available 24/7."
                    />
                  )}
                </Paragraph>
              </div>
            </div>
          }
          rowProps={{
            wrap: "reverse",
            style: { marginBottom: isMedium ? 24 : 48, alignItems: "start" },
          }}
        />
      </div>
    </div>
  );
}
